import * as React from "react";
import { connect } from "react-redux";
import Slider, { Settings as SliderSettings } from "react-slick";

import { Product } from "../../../models";
import * as selectors from "../selectors";
import { fetchFeaturedProducts } from "../actions";
import ProductCarouselItem from "./ProductCarouselItem";
import ProductCarousel from "./ProductCarousel";

export interface ProductCarouselContainerProps {
  products: Product[];
  fetchFeaturedProducts: () => void;
}

class ProductCarouselContainer extends React.Component<
  ProductCarouselContainerProps
> {
  private slider: Slider;
  private settings: SliderSettings = {
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  public componentDidMount(): void {
    this.props.fetchFeaturedProducts();
  }

  private assignRef = (el: Slider) => (this.slider = el);

  private handlePrev = () => {
    if (this.slider) {
      this.slider.slickPrev();
    }
  };

  private handleNext = () => {
    if (this.slider) {
      this.slider.slickNext();
    }
  };

  private renderProductCarouselItems = () =>
    this.props.products.map((props, i) => (
      <ProductCarouselItem key={i} {...props} />
    ));

  public render() {
    return (
      <ProductCarousel
        settings={this.settings}
        assignRef={this.assignRef}
        onNext={this.handleNext}
        onPrev={this.handlePrev}
      >
        {this.renderProductCarouselItems()}
      </ProductCarousel>
    );
  }
}

const mapStateToProps = state => ({
  products: selectors.featuredProducts(state),
});

const mapDispatchToProps = dispatch => ({
  fetchFeaturedProducts: () => dispatch(fetchFeaturedProducts()),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  ProductCarouselContainer,
);



// WEBPACK FOOTER //
// ./src/routes/ProductCarousel/components/ProductCarouselContainer.tsx